import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15 17.586L13.914 16.5l.793-.793a.999.999 0 1 0-1.414-1.414l-.793.793L11.414 14 14 11.414 17.586 15 15 17.586zM3.437 14.852l1.711 1.711-2.567.856.856-2.567zM4.914 7.5l.793-.793a.999.999 0 1 0-1.414-1.414l-.793.793L2.414 5 5 2.414 8.586 6 6 8.586 4.914 7.5zm12.551-4.965a1.83 1.83 0 0 1 0 2.586L17 5.586 14.414 3l.465-.465a1.83 1.83 0 0 1 2.586 0zM4.415 13L13 4.414 15.586 7 7 15.586 4.414 13zm15.292 1.293L15.414 10l3.465-3.465a3.832 3.832 0 0 0 0-5.414 3.834 3.834 0 0 0-5.414 0L10 4.586 5.707.293a.999.999 0 0 0-1.414 0l-4 4a.999.999 0 0 0 0 1.414L4.586 10l-2.293 2.293a.996.996 0 0 0-.24.391l-2 6a.998.998 0 0 0 1.263 1.264l6-2a.996.996 0 0 0 .391-.24L10 15.413l4.293 4.293a.997.997 0 0 0 1.414 0l4-4a.999.999 0 0 0 0-1.414z"
});

var SvgToolsMajorMonotone = function SvgToolsMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgToolsMajorMonotone as S };
